import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
import "../../Style/LandingPage/PromotionBanner.css";
import { Link, useNavigate } from "react-router-dom";

const PromotionBanner = ({ position }) => {
  const [banners, setBanners] = useState(null);
  const navigate = useNavigate();

  var settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  async function getBanner() {
    try {
      const res = await axios.get("/api/banner/get-all-banner");
      if (res.data.success) {
        setBanners(res.data.data.banners);
      } else {
        console.log(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getBanner();
  }, []);

const bannerArray = banners ? banners[position] : [];

// console.log("Position prop:", position);
// console.log("Current banner array:", bannerArray);

  return (
    <div className={`${banners && "container-fluid promotional__banner"}`}>
     {bannerArray.length > 0 ? (
  <Slider {...settings}>
    {bannerArray.map((item, index) => {
      return (
        <Link key={index} to={`category/${item.location}`}>
          <img
            src={`https://highmountains.in/trip/gallery/${item.image}`}
            alt={item.location}
          />
        </Link>
      );
    })}
  </Slider>
) : (
  ""
)}

    </div>
  );
};

export default PromotionBanner;
